import { useCallback, useContext } from 'react';
import AuthContext from 'providers/Auth/Auth.context';
import { BUSINESS_ROUTE } from 'data/global';
import { getSellingPortfolio } from 'utils';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export default function useOnClose() {
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const { dealRoomId } = useParams();

  const { previousLocation } = useContext(AuthContext);
  const prevLocPathname = previousLocation?.pathname;

  return useCallback(() => {
    navigate(
      dealRoomId
        ? getSellingPortfolio(dealRoomId, 'listing-information')
        : prevLocPathname && prevLocPathname !== pathname
        ? prevLocPathname
        : BUSINESS_ROUTE,
      { replace: true },
    );
  }, [dealRoomId, navigate, pathname, prevLocPathname]);
}
